const host = process.env.VUE_APP_URL_SECURITY_API;

export default class Endpoint {
  public static readonly Url = {
    profile: {
      index: `${host}/api/profile/index`,
      getById: `${host}/api/profile`,
      create: `${host}/api/profile/create`,
      update: `${host}/api/profile`,
      getAllAreas: `${host}/api/profile/areas`,
      getApplications: `${host}/api/profile/applications`,
      getProfiles: `${host}/api/profile/getbyapplication`
    },
    user: {
      index: `${host}/api/user/filter`,
      getById: `${host}/api/user/getbyid`,
      getByEmail: `${host}/api/user/getbyemail`,
      create: `${host}/api/user/create`,
      update: `${host}/api/user/update`
    }
  };
}
